var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-tree 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.60039 2.40002C7.38815 2.40002 5.55676 3.92304 5.00547 5.96838C3.46844 6.76897 2.40039 8.35206 2.40039 10.2C2.40039 12.8439 4.55653 15 7.20039 15H9.00039V16.8H10.2004V12.8485L13.0246 10.0242L12.1762 9.17581L10.2004 11.1516V6.00002H9.00039V9.95159L7.02461 7.97581L6.17617 8.82424L9.00039 11.6485V13.8H7.20039C5.20505 13.8 3.60039 12.1954 3.60039 10.2C3.60039 8.73218 4.47555 7.47941 5.72852 6.91643L6.01094 6.78987L6.07187 6.48752C6.40232 4.84144 7.84974 3.60002 9.60039 3.60002C11.351 3.60002 12.7985 4.84144 13.1289 6.48752L13.1898 6.78987L13.4723 6.91643C14.7252 7.47941 15.6004 8.73218 15.6004 10.2C15.6004 12.1954 13.9957 13.8 12.0004 13.8H11.4004V15H12.0004C14.6443 15 16.8004 12.8439 16.8004 10.2C16.8004 8.35206 15.7323 6.76897 14.1953 5.96838C13.644 3.92304 11.8126 2.40002 9.60039 2.40002Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/treeIcon.5e77d7617671036fcc524a9caf64b7d1.svg";
export { ForwardRef as ReactComponent };